/*
 * WaitingForApprovalPage Messages
 *
 * This contains all the text for the WaitingForApprovalPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'waitingForApproval';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Waiting for your access to be approved',
  },
});
